module.exports = __webpack_public_path__ + "media/images/lb/755-2bbf991bb94f59e3c0fe1872e4609699.svg";